<div
  class="multi-select"
  [style.marginRight.px]="filterMarginRight"
  [style.marginBottom.px]="filterMarginBottom"
  [ngClass]="{
    disabled: isDisabled
  }"
>
  <div
    class="trigger"
    class="filter-wrapper"
    (menuClosed)="menuClosed()"
    (menuOpened)="menuOpened()"
    [matMenuTriggerFor]="menu"
  >
    <span
      *ngIf="isMandatory && mandatorySymbolPosition == 'left'"
      class="asterick"
      >*</span
    >
    <span> {{ displayName }} : </span>
    <span
      *ngIf="!selectedOptionsStr.length"
      class="selected-option placeholder-text"
    >
      {{ displayName }}
      <mat-icon class="arrow">expand_more</mat-icon>
    </span>
    <ng-container *ngIf="selectedOptionsStr.length">
      <span
        class="selected-option"
        [ngStyle]="{
          maxWidth: autoSelectedOptionWidth ? 'fit-content' : '120px'
        }"
      >
        <span
          class="ellipsis"
          [ngStyle]="{
            maxWidth: autoSelectedOptionWidth ? 'fit-content' : '132px'
          }"
        >
          {{ ALL.selected ? "All" : selectedOptionsStr }}
        </span>
        <mat-icon class="arrow">expand_more</mat-icon>
      </span>
    </ng-container>

    <span
      *ngIf="isMandatory && mandatorySymbolPosition == 'right'"
      class="asterick"
      >*</span
    >
  </div>

  <mat-menu
    #menu="matMenu"
    [overlapTrigger]="false"
    (opened)="isMenuOpen = true"
    (closed)="isMenuOpen = false"
    (click)="$event.stopPropagation()"
  >
    <div [style.width.px]="menuWidth">
      <div
        style="
          width: 100%;
          align-items: center;
          grid-template-columns: 1fr;
          display: grid;
          height: calc(100%);
          justify-items: center;
        "
        *ngIf="enableSearch"
      >
        <!-- <mat-form-field
          [style.width.px]="menuWidth - 30"
          appearance="fill"
          (click)="$event.stopPropagation()"
          class="search-input"
        >
          <mat-icon matPrefix>search</mat-icon>
          <input
            matInput
            type="text"
            (mousedown)="$event.stopPropagation()"
            #searchInput
            (input)="filterOptions(searchInput.value)"
            placeholder="search"
          />
        </mat-form-field> -->
        <input
          #inputSearch
          class="form-control"
          placeholder="search"
          #searchInput
          (click)="$event.stopPropagation()"
          (keyup)="filterOptions(searchInput.value)"
        />
        <!-- (keyup)="filterColumnValues($event, $event.target.value)" -->
      </div>
      <div class="scrollable-options">
        <ng-container *ngIf="!isSingleSelection && optionAllPresent">
          <button
            *ngIf="filteredOptions.length"
            mat-menu-item
            class="fixed-all-option"
            style="background-color: white"
          >
            <label class="checkbox-container label">
              <mat-checkbox
                [checked]="isSelected(ALL)"
                (click)="$event.stopPropagation()"
                (change)="toggleSelection(ALL)"
                [color]="'primary'"
              ></mat-checkbox>
              <span> All </span>
              <span class="checkmark"></span>
            </label>
          </button>
        </ng-container>
        <ng-container *ngIf="filteredOptions.length > 0; else noResults">
          <ng-container *ngFor="let option of filteredOptions">
            <button
              mat-menu-item
              [class.fixed-all-option]="option.id === 0"
              [disabled]="option.disabled"
            >
              <label
                class="checkbox-container label"
                (click)="$event.stopPropagation()"
              >
                <ng-container
                  *ngIf="!isSingleSelection || !showRadioBtnForSingleSelection"
                >
                  <mat-checkbox
                    [checked]="isSelected(option)"
                    (click)="$event.stopPropagation()"
                    (change)="
                      !isSingleSelection
                        ? toggleSelection(option)
                        : singleSelection(option)
                    "
                    [color]="'primary'"
                  >
                  </mat-checkbox>
                </ng-container>
                <ng-container
                  *ngIf="isSingleSelection && showRadioBtnForSingleSelection"
                >
                  <div class="checkbox-wrap">
                    <input
                      type="radio"
                      (click)="
                        !isSingleSelection
                          ? toggleSelection(option)
                          : singleSelection(option)
                      "
                      [checked]="isSelected(option)"
                      [name]="option.name"
                      id=""
                      [ngStyle]="{
                        marginTop: isSelected(option) ? '0px' : '4px'
                      }"
                    />
                  </div>
                </ng-container>
                <span style="white-space: initial">
                  {{ option.name }}
                </span>
                <span class="checkmark"></span>
              </label>
            </button>
          </ng-container>
        </ng-container>
      </div>

      <ng-template #noResults>
        <span class="no-results">No results found</span>
      </ng-template>
    </div>

    <div
      *ngIf="!isSingleSelection"
      class="button-container"
      style="padding-bottom: 8px"
    >
      <button mat-button (click)="clearSelections()">
        <!-- [ngStyle]="{ visibility: isClearActive ? 'visible' : 'hidden' }" -->
        Clear
      </button>
      <button mat-button color="primary" (click)="applySelections()">
        Apply
      </button>
    </div>
  </mat-menu>
</div>
